import { Controller } from "@hotwired/stimulus"

// After a heart on a post nobody has answered: the box where the words would
// go comes into view and takes the caret, with a placeholder from the moment,
// so the heart becomes the first step toward a line rather than a way out of
// one. Nothing is typed for the reader; the field is simply made ready. If
// they are already writing somewhere on the page, nothing moves.
export default class extends Controller {
  static values = { placeholder: String }

  connect() {
    const field = document.querySelector("#letter_composer textarea")
    if (!field) return
    if (document.activeElement && document.activeElement.matches("textarea, input")) return

    if (this.hasPlaceholderValue && !field.value) field.placeholder = this.placeholderValue

    field.scrollIntoView({ behavior: "smooth", block: "center" })
    // Focus after the scroll has begun, so the browser does not jump instead.
    setTimeout(() => field.focus({ preventScroll: true }), 350)
  }
}
